import React, { useEffect } from 'react'

import { loadCuratedPlaylists } from '@disco/state-management/actions/playlist-actions'
import { getCuratedPlaylists } from '@disco/state-management/selectors/playlists'

import { useDispatch, useSelector } from 'hooks/use-redux'

import CuratedPlaylistsSection from './CuratedPlaylistsSection'

const CuratedPlaylistsSectionContainer = (): null | React.ReactNode => {
  const dispatch = useDispatch()
  const curatedPlaylists = useSelector(getCuratedPlaylists)
  const isLoading = curatedPlaylists.loading && !curatedPlaylists.loaded

  useEffect(() => {
    if (!curatedPlaylists.loading && !curatedPlaylists.loaded) {
      dispatch(loadCuratedPlaylists())
    }
  }, [])

  if (!isLoading && curatedPlaylists.items.length === 0) {
    return null
  }

  return (
    <CuratedPlaylistsSection
      curatedPlaylists={curatedPlaylists.items}
      loading={isLoading}
    />
  )
}

export default CuratedPlaylistsSectionContainer
